import {AmsDataGridColumnDef} from "../../framework/component/data-grid/AmsDataGrid";

const headerClassName = 'grid-header';

export const sysPrefListColumns: AmsDataGridColumnDef[] = [
  {
    field: 'prefName',
    headerName: 'ID',
    type: 'string',
    flex: .20,
    filterable: false,
    headerClassName: headerClassName
  },
  {
    field: 'displayName',
    headerName: 'Preference',
    type: 'string',
    flex: .25,
    filterable: false,
    headerClassName: headerClassName,
  },
  {
    field: 'category',
    headerName: 'Category',
    type: 'string',
    flex: .15,
    filterable: false,
    headerClassName: headerClassName,
  },
  {
    field: 'prefValue',
    headerName: 'Value',
    type: 'string',
    flex: .20,
    filterable: false,
    headerClassName: headerClassName,
  },
  {
    field: 'startupRequired',
    headerName: 'Startup Required',
    flex: .10,
    filterable: false,
    headerClassName: headerClassName
  },
  {
    field: 'defaultValue',
    headerName: 'Default Value',
    type: 'string',
    flex: .20,
    filterable: false,
    headerClassName: headerClassName,
  },
  {
    field: 'helpText',
    headerName: 'Help Text',
    type: 'string',
    flex: .15,
    filterable: false,
    headerClassName: headerClassName,
  },
  {
    field: 'dataType',
    headerName: 'Data Type',
    type: 'string',
    flex: .10,
    filterable: false,
    headerClassName: headerClassName,
  },
];
